import { useMemo } from 'react';
import { ISectionData } from '../../../components/layouts/Sections/Section/Section.types';
import { find, groupBy, map, pipe, prop, propEq, toPairs } from 'ramda';
import { useMMGRSettings } from '../../../utils/hoc/withMMGRSettings';
import { MediaManagerSDKAnyItemWithSectionInfo } from '../../../utils/media-manager-sdk';

export const useSections = (items: MediaManagerSDKAnyItemWithSectionInfo[]) => {
  const { mmgrSettings } = useMMGRSettings();
  return useMemo<ISectionData[]>(
    () =>
      pipe(
        groupBy(prop('sectionTitle')),
        toPairs,
        map(([sectionTitle, item]) => ({
          title: sectionTitle,
          sectionName: sectionTitle,
          data: item,
          action: pipe(find(propEq('title', sectionTitle)), prop('action'))(mmgrSettings.customData.sections),
        })),
      )(items) as ISectionData[],
    [items, mmgrSettings.customData],
  );
};
